var _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCode = function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#code_svg__a)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 57.188,
    height: 65.188,
    x: 5.406,
    y: -7.945
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#code_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#code_svg__c)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#code_svg__d)",
    d: "M16 12.8c0-4.48 0-6.72.872-8.432A8 8 0 0 1 20.368.872C22.08 0 24.32 0 28.8 0h10.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C52 6.08 52 8.32 52 12.8v18.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496C45.92 44 43.68 44 39.2 44H28.8c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C16 37.92 16 35.68 16 31.2z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    d: "M28.8.5h10.4c2.249 0 3.905 0 5.214.107 1.303.107 2.218.316 2.991.71a7.5 7.5 0 0 1 3.278 3.278c.394.773.603 1.688.71 2.99.106 1.31.107 2.966.107 5.215v18.4c0 2.249 0 3.905-.107 5.214-.107 1.303-.316 2.218-.71 2.991a7.5 7.5 0 0 1-3.278 3.278c-.773.394-1.688.603-2.99.71-1.31.106-2.966.107-5.215.107H28.8c-2.249 0-3.905 0-5.214-.107-1.303-.107-2.218-.316-2.991-.71a7.5 7.5 0 0 1-3.278-3.278c-.394-.773-.603-1.688-.71-2.99-.107-1.31-.107-2.966-.107-5.215V12.8c0-2.249 0-3.905.107-5.214.107-1.303.316-2.218.71-2.991a7.5 7.5 0 0 1 3.278-3.278c.773-.394 1.688-.603 2.99-.71C24.896.5 26.552.5 28.8.5Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 57.188,
    height: 65.188,
    x: -0.594,
    y: -1.945
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#code_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#code_svg__f)",
    shapeRendering: "crispEdges"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#code_svg__g)",
    fillOpacity: 0.5,
    d: "M10 18.8c0-4.48 0-6.72.872-8.432a8 8 0 0 1 3.496-3.496C16.08 6 18.32 6 22.8 6h10.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C46 12.08 46 14.32 46 18.8v18.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496C39.92 50 37.68 50 33.2 50H22.8c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C10 43.92 10 41.68 10 37.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#code_svg__h)",
    fillOpacity: 0.25,
    d: "M10 18.8c0-4.48 0-6.72.872-8.432a8 8 0 0 1 3.496-3.496C16.08 6 18.32 6 22.8 6h10.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C46 12.08 46 14.32 46 18.8v18.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496C39.92 50 37.68 50 33.2 50H22.8c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C10 43.92 10 41.68 10 37.2z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    strokeWidth: 0.375,
    d: "M22.8 6.188h10.4c2.243 0 3.915 0 5.24.108 1.322.108 2.282.323 3.107.743a7.8 7.8 0 0 1 3.414 3.414c.42.825.635 1.785.743 3.108s.108 2.996.108 5.239v18.4c0 2.243 0 3.915-.108 5.24-.108 1.322-.323 2.282-.743 3.107a7.8 7.8 0 0 1-3.414 3.414c-.825.42-1.785.635-3.107.743-1.325.108-2.997.108-5.24.108H22.8c-2.243 0-3.915 0-5.24-.108-1.322-.108-2.282-.323-3.107-.743a7.8 7.8 0 0 1-3.414-3.414c-.42-.825-.635-1.785-.743-3.107-.108-1.325-.108-2.997-.108-5.24V18.8c0-2.243 0-3.915.108-5.24.108-1.322.323-2.282.743-3.107a7.8 7.8 0 0 1 3.414-3.414c.825-.42 1.785-.635 3.108-.743s2.996-.109 5.239-.109Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 57.188,
    height: 65.188,
    x: -6.594,
    y: 4.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#code_svg__i)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#code_svg__j)",
    shapeRendering: "crispEdges"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#code_svg__k)",
    fillOpacity: 0.2,
    d: "M4 24.8c0-4.48 0-6.72.872-8.432a8 8 0 0 1 3.496-3.496C10.08 12 12.32 12 16.8 12h10.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C40 18.08 40 20.32 40 24.8v18.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496C33.92 56 31.68 56 27.2 56H16.8c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C4 49.92 4 47.68 4 43.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#code_svg__l)",
    d: "M4 24.8c0-4.48 0-6.72.872-8.432a8 8 0 0 1 3.496-3.496C10.08 12 12.32 12 16.8 12h10.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C40 18.08 40 20.32 40 24.8v18.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496C33.92 56 31.68 56 27.2 56H16.8c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C4 49.92 4 47.68 4 43.2z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M16.8 12.5h10.4c2.249 0 3.905 0 5.214.107 1.303.107 2.218.316 2.991.71a7.5 7.5 0 0 1 3.278 3.278c.394.773.603 1.688.71 2.99.106 1.31.107 2.966.107 5.215v18.4c0 2.249 0 3.905-.107 5.214-.107 1.303-.316 2.218-.71 2.991a7.5 7.5 0 0 1-3.278 3.278c-.773.394-1.688.603-2.99.71-1.31.106-2.966.107-5.215.107H16.8c-2.249 0-3.905 0-5.214-.107-1.303-.107-2.218-.316-2.991-.71a7.5 7.5 0 0 1-3.278-3.278c-.394-.773-.603-1.688-.71-2.99C4.5 47.104 4.5 45.448 4.5 43.2V24.8c0-2.249 0-3.905.107-5.214.107-1.303.316-2.218.71-2.991a7.5 7.5 0 0 1 3.278-3.278c.773-.394 1.688-.603 2.99-.71 1.31-.106 2.966-.107 5.215-.107Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#code_svg__m)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#code_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m15.758 28-4.587 3.44c-1.158.869-1.737 1.303-1.944 1.835a2 2 0 0 0 0 1.45c.207.532.786.966 1.944 1.835L15.758 40"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#code_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m27.758 28 4.586 3.44c1.158.869 1.737 1.303 1.944 1.835a2 2 0 0 1 0 1.45c-.207.532-.786.966-1.944 1.835L27.758 40"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "code_svg__c",
    width: 57.188,
    height: 65.188,
    x: 5.406,
    y: -7.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "code_svg__f",
    width: 57.188,
    height: 65.188,
    x: -0.594,
    y: -1.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "code_svg__j",
    width: 57.188,
    height: 65.188,
    x: -6.594,
    y: 4.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "code_svg__m",
    width: 8.918,
    height: 22.352,
    x: 17.293,
    y: 23.423,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4772_4418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4772_4418",
    result: "effect2_dropShadow_4772_4418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4772_4418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "code_svg__n",
    width: 10.666,
    height: 16,
    x: 7.092,
    y: 27,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4772_4418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4772_4418",
    result: "effect2_dropShadow_4772_4418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4772_4418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "code_svg__o",
    width: 10.666,
    height: 16,
    x: 25.758,
    y: 27,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4772_4418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4772_4418",
    result: "effect2_dropShadow_4772_4418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4772_4418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "code_svg__b",
    transform: "translate(-5.406 7.945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 12.8c0-4.48 0-6.72.872-8.432A8 8 0 0 1 20.368.872C22.08 0 24.32 0 28.8 0h10.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C52 6.08 52 8.32 52 12.8v18.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496C45.92 44 43.68 44 39.2 44H28.8c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C16 37.92 16 35.68 16 31.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "code_svg__e",
    transform: "translate(.594 1.945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.8c0-4.48 0-6.72.872-8.432a8 8 0 0 1 3.496-3.496C16.08 6 18.32 6 22.8 6h10.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C46 12.08 46 14.32 46 18.8v18.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496C39.92 50 37.68 50 33.2 50H22.8c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C10 43.92 10 41.68 10 37.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "code_svg__i",
    transform: "translate(6.594 -4.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 24.8c0-4.48 0-6.72.872-8.432a8 8 0 0 1 3.496-3.496C10.08 12 12.32 12 16.8 12h10.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C40 18.08 40 20.32 40 24.8v18.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496C33.92 56 31.68 56 27.2 56H16.8c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C4 49.92 4 47.68 4 43.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "code_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "code_svg__d",
    x1: 35.125,
    x2: 35.125,
    y1: 0.647,
    y2: 73.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "code_svg__g",
    x1: 28,
    x2: 28,
    y1: 25.525,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "code_svg__k",
    x1: 22,
    x2: 22,
    y1: 31.525,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "code_svg__h",
    width: 1.778,
    height: 1.455,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#code_svg__p",
    transform: "scale(.00174 .00142)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "code_svg__l",
    width: 1.778,
    height: 1.455,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#code_svg__p",
    transform: "scale(.00174 .00142)"
  })))));
};
export default SvgCode;